import { render } from "./PonAbonents.vue?vue&type=template&id=7429f773&scoped=true"
import script from "./PonAbonents.vue?vue&type=script&lang=js"
export * from "./PonAbonents.vue?vue&type=script&lang=js"

import "./PonAbonents.vue?vue&type=style&index=0&id=7429f773&scoped=true&lang=css"
import "./PonAbonents.vue?vue&type=style&index=1&id=7429f773&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7429f773"]])

export default __exports__